module.exports = __webpack_public_path__ + "static/img/LATINA-OAK.2074a1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/LATINA-OAK.png
// module id = cEhh
// module chunks = 0